import { render } from "./OrderInfosModal.vue?vue&type=template&id=aa9a28be&scoped=true&ts=true&lang=pug"
import script from "./OrderInfosModal.vue?vue&type=script&lang=ts"
export * from "./OrderInfosModal.vue?vue&type=script&lang=ts"

import "./OrderInfosModal.vue?vue&type=style&index=0&id=aa9a28be&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9a28be"]])

export default __exports__